import { Icon } from "armstrong-react";
import React from "react";
import { actions, Control } from "react-redux-form";
import { Errors } from "../../../../../core/atoms/rrf";

interface Props {
  name: string;
  model: string;
  passwordModel: string;
  validators?: any;
  errorsObject: any;
  dispatch: any;
  formState: Forms.EnquiryForm;
}

export class PasswordField extends React.Component<Props> {
  /**
   * Couldn't get an extra <Form> wrapper working as per the docs so doing this manually.
   */
  private validatePasswordConfirmation = () => {
    const accountModel = this.props.formState.account;

    // Always validate true if on the sign in form, or if the password field is invalid (since that will show errors)
    const confIsValid = accountModel && (
      accountModel.hasAccount || accountModel.password == accountModel.passwordConfirmation
    );

    this.props.dispatch(actions.setValidity(`${this.props.model}.passwordConfirmation`, { passwordsMatch: confIsValid }));

    // Set on failed sign in; always clear if field is modified
    this.props.dispatch(actions.setValidity(`${this.props.model}.password`, { signInFailed: true }));
  }

  private toggleShowPasswords = () => {
    const modelString = `${this.props.model}.isShowingPasswords`;
    const newIsShowing = !this.props.formState.account.isShowingPasswords;
    this.props.dispatch(actions.change(modelString, newIsShowing));
  }

  public render() {
    const isShowingPasswords = this.props.formState.account.isShowingPasswords;
    return (
      <label className="password-label">
        <div className="label">
          {this.props.name}
          <a className="password-visibility-toggle" onClick={this.toggleShowPasswords}>
            {isShowingPasswords ? "Hide" : "Show"}<Icon icon={isShowingPasswords ? Icon.Icomoon.eyeBlocked3 : Icon.Icomoon.eye3} />
          </a>
        </div>
        <Control.text model={this.props.passwordModel}
                      type={isShowingPasswords ? "text" : "password"}
                      validators={this.props.validators}
                      validateOn="blur"
                      onSubmit={this.validatePasswordConfirmation}
                      onBlur={this.validatePasswordConfirmation} />
        <Errors model={this.props.passwordModel} messages={this.props.errorsObject} show={x => x.submitFailed || (x.touched && !x.pristine)} />
      </label>
    );
  }
}
